import { toAbsoluteShareUrl } from "./condividiSuSocial";
import { sanitizeSharePathname } from "./villageSlug";

export const FOTO_QUERY_PARAM = "foto";

/**
 * Canonical scheda URL (no ?foto / ?img) for "Condividi questa scheda".
 * Never falls back to bare homepage when a path or current location exists.
 * Strips Facebook paste junk from path segments (spaces / trailing marketing text).
 */
export function schedaShareUrl(urlOrPath) {
  const abs = toAbsoluteShareUrl(
    urlOrPath || (typeof window !== "undefined" ? window.location.href : "")
  );
  try {
    const u = new URL(abs);
    u.pathname = sanitizeSharePathname(u.pathname);
    u.searchParams.delete(FOTO_QUERY_PARAM);
    u.searchParams.delete("img");
    u.hash = "";
    // Guard: refuse bare origin as "scheda" if caller gave an empty string by mistake
    if (u.pathname === "/" || u.pathname === "") {
      if (typeof window !== "undefined" && window.location.pathname !== "/") {
        return schedaShareUrl(window.location.pathname + window.location.search);
      }
    }
    return u.toString();
  } catch {
    return abs;
  }
}

/** 1-based photo index from ?foto=N (or null if missing/invalid). */
export function parseFotoQueryParam(searchOrParams) {
  let raw = null;
  if (typeof searchOrParams === "string") {
    const q = searchOrParams.startsWith("?") ? searchOrParams.slice(1) : searchOrParams;
    raw = new URLSearchParams(q).get(FOTO_QUERY_PARAM);
  } else if (searchOrParams && typeof searchOrParams.get === "function") {
    raw = searchOrParams.get(FOTO_QUERY_PARAM);
  } else if (typeof window !== "undefined") {
    raw = new URLSearchParams(window.location.search).get(FOTO_QUERY_PARAM);
  }
  const n = parseInt(String(raw || "").trim(), 10);
  if (!Number.isFinite(n) || n < 1) return null;
  return n;
}

/** 0-based gallery index from ?foto=, clamped to gallery length. */
export function fotoQueryToIndex(searchOrParams, galleryLength) {
  const oneBased = parseFotoQueryParam(searchOrParams);
  if (oneBased == null || !galleryLength) return null;
  const idx = oneBased - 1;
  if (idx < 0 || idx >= galleryLength) return null;
  return idx;
}

/**
 * Deep link that opens this scheda with photo N in lightbox.
 * @param {string} [baseUrl] path or absolute URL of the scheda
 * @param {number} zeroBasedIndex
 */
export function buildPhotoDeepLink(baseUrl, zeroBasedIndex) {
  const base = schedaShareUrl(baseUrl);
  const n = Math.max(0, Math.floor(Number(zeroBasedIndex) || 0)) + 1;
  try {
    const u = new URL(base);
    u.searchParams.set(FOTO_QUERY_PARAM, String(n));
    return u.toString();
  } catch {
    const sep = base.includes("?") ? "&" : "?";
    return `${base}${sep}${FOTO_QUERY_PARAM}=${n}`;
  }
}

/**
 * Sync ?foto= in the address bar without navigation (replaceState).
 * Pass null to remove the param.
 */
export function syncFotoQueryInUrl(zeroBasedIndexOrNull) {
  if (typeof window === "undefined") return;
  try {
    const u = new URL(window.location.href);
    if (zeroBasedIndexOrNull == null || zeroBasedIndexOrNull < 0) {
      u.searchParams.delete(FOTO_QUERY_PARAM);
    } else {
      u.searchParams.set(FOTO_QUERY_PARAM, String(Math.floor(zeroBasedIndexOrNull) + 1));
    }
    window.history.replaceState(window.history.state, "", `${u.pathname}${u.search}${u.hash}`);
  } catch {
    /* ignore */
  }
}
